import React, { useRef, useEffect, useState } from 'react';
import './HeroSlider.css';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HeroSlider = () => {
  const socialIcons = [
    {
      icon: faInstagram,
      link: "https://www.instagram.com/fabgold_official/",
      target: "_blank"
    },
    {
      icon: faFacebookF,
      link: "https://www.facebook.com/share/1C5DzmY64D/",
      target: "_blank"
    },
    {
      icon: faWhatsapp,
      link: "https://wa.me/917012065100",
      target: "_blank"
    }
  ];

  const [sliderHeight, setSliderHeight] = useState(window.innerHeight);
  const [scrolling, setScrolling] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;

      if (!scrolling && scrollPosition > 0) {
        setScrolling(true);
      } else if (scrolling && scrollPosition === 0) {
        setScrolling(false);
      }

      if (videoRef.current) {
        const speed = 0.3;
        videoRef.current.style.transform = `translateY(-${scrollPosition * speed}px)`;
        setSliderHeight(window.innerHeight - scrollPosition);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolling]);

  return (
    <div className='relative hero-slider' style={{ height: sliderHeight }}>
      {/* Fallback image shown until video loads */}
      {!videoLoaded && (
        <img
          src="./images/homevideo.webp"
          alt="Fallback"
          className="absolute inset-0 w-full h-full object-cover z-10"
        />
      )}

      {/* Video with onCanPlayThrough event */}
      <video
        ref={videoRef}
        className={`hero-video ${videoLoaded ? 'z-20' : 'z-0'}`}
        src="./images/bgvideo.mp4"
        width="100%"
        autoPlay
        muted
        playsInline
        loop
        style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0 }}
        onCanPlayThrough={() => setVideoLoaded(true)}
      />

      <div className='flex flex-row'>
        <div className='absolute top-1/2 transform -translate-y-1/2 left-4 flex flex-col max-sm:hidden space-y-4'>
          {socialIcons.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target={social.target}
              className="hover:cursor-pointer text-white text-[13px] max-sm:text-[8px] leading-[15px] max-sm:leading-[8px] w-[30px] max-sm:w-[10px] h-[30px] max-sm:h-[10px] rounded-full py-2 bg-tertary2 text-center hover:bg-gold"
            >
              <FontAwesomeIcon icon={social.icon} />
            </a>
          ))}
        </div>
        <div className="left-[76px] max-sm:left-0 absolute inset-0 flex flex-col items-center justify-center text-center text-white">
          <h2 className='text-2xl md:text-6xl lg:text-8xl font-bold mb-4 text-white'>FAB GOLD</h2>
          <p className='text-white text-base md:text-xl lg:text-2xl mb-5 px-4'>
            World-class Gold Jewellery, handcrafted with integrity and quality
          </p>
          {!scrolling && (
            <div className="absolute bottom-8 w-full flex justify-center">
              <FontAwesomeIcon
                icon={faAnglesDown}
                style={{ color: "#ffffff", fontSize: "3rem", animation: "bounce 2s infinite" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;



// import React, { useRef, useEffect, useState } from 'react';
// import './HeroSlider.css'; // Import CSS file for styling
// // Import FontAwesome icon for scroll down
// import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import { faAnglesDown } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


// const HeroSlider = () => {
  
//   const socialIcons = [
//     {
//       icon : faInstagram,
//       link : "https://www.instagram.com/fabgold_official/",
//       target: "_blank"
//     },
//     {
//       icon : faFacebookF, 
//       link : "https://www.facebook.com/share/1C5DzmY64D/",
//       target: "_blank" 
//     },
//     {
//       icon : faWhatsapp, 
//       link : "https://wa.me/917012065100",
//       target: "_blank" 
//     }
//   ];

//   const [sliderHeight, setSliderHeight] = useState(window.innerHeight);
//   const [scrolling, setScrolling] = useState(false);
//   const videoRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollPosition = window.pageYOffset;
      
//       if (!scrolling && scrollPosition > 0) {
//         setScrolling(true);
//       } else if (scrolling && scrollPosition === 0) {
//         setScrolling(false);
//       }

//       if (videoRef.current) {
//         const speed = 0.3; // Adjust the speed of parallax effect

//         videoRef.current.style.transform = `translateY(-${scrollPosition * speed}px)`;
//         setSliderHeight(window.innerHeight - scrollPosition); // Adjust slider height based on scroll position
//       }
//     };

//     // Add event listener for scroll
//     window.addEventListener('scroll', handleScroll);

//     // Cleanup function to remove event listener when component unmounts
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, [scrolling]);

//   return (
//     <div className='relative hero-slider' style={{ height: sliderHeight}}>
//       <video ref={videoRef} className='hero-video' src="./images/bgvideo.mp4" width="100%" autoPlay muted playsInline loop style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
//       <div className='flex flex-row'>
//         <div className='absolute top-1/2 transform -translate-y-1/2 left-4 flex flex-col max-sm:hidden space-y-4'>
//           {socialIcons.map((social, index) => (
//             <a 
//               key={index} 
//               href={social.link} 
//               target={social.target}
//               className="hover:cursor-pointer text-white text-[13px] max-sm:text-[8px] leading-[15px] max-sm:leading-[8px] w-[30px] max-sm:w-[10px] h-[30px] max-sm:h-[10px] rounded-full py-2 bg-tertary2 text-center hover:bg-gold"
//             >
//               <FontAwesomeIcon icon={social.icon}  />
//             </a>
//           ))}
//         </div>
//         <div className="left-[76px] max-sm:left-0 absolute inset-0 flex flex-col items-center justify-center text-center text-white">
//           <h2 className='text-2xl md:text-6xl lg:text-8xl font-bold mb-4 text-white'>FAB GOLD</h2>
//           <p className='text-white text-base md:text-xl lg:text-2xl mb-5 px-4'>World-class Gold Jewellery, handcrafted with integrity and quality</p>
//           {!scrolling && (
//             <div className="absolute bottom-8 w-full flex justify-center">
//               <FontAwesomeIcon icon={faAnglesDown} style={{ color: "#333333", fontSize: "3rem", animation: "bounce 2s infinite" }} />
//             </div>
//           )}
          
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeroSlider;